import { MapPin, Star, SealCheck, CalendarCheck } from "@phosphor-icons/react";
import { E, EImg } from "@/components/Editable";

const ACCENTS = { career: "#10B981", relationships: "#EC4899", health: "#22D3EE" };

export const ReaderCard = ({ reader, selected, onSelect }) => {
  const accent = ACCENTS[reader.specialty] || "#D4AF37";
  const rk = (s) => `reader_${reader.id}_${s}`;
  const bookNow = (e) => {
    e.stopPropagation();
    onSelect();
    document.getElementById("schedule")?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(e) => { if (e.key === "Enter") onSelect(); }}
      data-testid={`reader-card-${reader.id}`}
      className={`cursor-pointer text-left p-6 border transition-colors duration-300 hover-lift flex flex-col ${
        selected ? "border-gold bg-gold/5" : "border-white/10 bg-card"
      }`}
    >
      <div className="flex items-start gap-4">
        <EImg
          k={rk("image")}
          f={reader.image}
          alt={reader.name}
          wrapClassName="shrink-0"
          className="w-20 h-20 rounded-full object-cover border-2 shrink-0"
          style={{ borderColor: selected ? "#D4AF37" : `${accent}66` }}
        />
        <div className="min-w-0">
          <h3 className="font-heading text-xl font-semibold tracking-tight flex items-center gap-1.5">
            <E k={rk("name")} f={reader.name} /> <SealCheck size={16} weight="fill" className="text-gold shrink-0" />
          </h3>
          <p className="font-heading italic text-sm text-muted-foreground"><E k={rk("title")} f={reader.title} /></p>
          <p className="flex items-center gap-1 text-[10px] uppercase tracking-widest text-muted-foreground mt-1.5">
            <MapPin size={12} /> <E k={rk("location")} f={reader.location} />
          </p>
        </div>
      </div>
      <span
        className="inline-block self-start mt-4 text-[10px] uppercase tracking-[0.2em] font-bold px-3 py-1 border"
        style={{ color: accent, borderColor: `${accent}55` }}
      >
        <E k={rk("specialty_label")} f={reader.specialty_label} />
      </span>
      <p className="mt-3 text-xs text-muted-foreground leading-relaxed"><E k={rk("bio")} f={reader.bio} /></p>
      <ul className="mt-4 flex flex-wrap gap-1.5">
        {reader.expertise.map((e) => (
          <li key={e} className="text-[10px] px-2 py-1 border border-white/10 text-foreground/80">{e}</li>
        ))}
      </ul>
      <div className="mt-4 pt-4 border-t border-white/10 flex items-center justify-between text-xs text-muted-foreground">
        <span>{reader.experience_years}+ yrs</span>
        <span>{reader.readings_done.toLocaleString()}+ readings</span>
        <span className="flex items-center gap-1 text-gold" data-testid={`reader-rating-${reader.id}`}>
          <Star size={12} weight="fill" /> {Number(reader.rating).toFixed(1)}
        </span>
      </div>
      <p className="mt-2 text-[10px] text-muted-foreground">Speaks: {reader.languages.join(", ")}</p>
      <button
        onClick={bookNow}
        data-testid={`reader-book-now-${reader.id}`}
        className="mt-4 w-full inline-flex items-center justify-center gap-2 py-3 rounded-full bg-gold text-black text-[11px] uppercase tracking-[0.2em] font-bold hover:bg-[#e8c95a] transition-colors duration-300"
      >
        <CalendarCheck size={14} weight="bold" /> Book Now
      </button>
    </div>
  );
};
